<template>
  <div id="sneosapp">
    <md-dialog :md-active.sync="showDialog">
      <md-app md-waterfall md-mode="fixed-last">
        <md-app-toolbar class="md-dense md-primary">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <md-button
                class="md-icon-button"
                @click="leftSideMenuVisible = !leftSideMenuVisible"
              >
                <md-icon>menu</md-icon>
              </md-button>

              <section v-if="showNavRow" style="display: none">
                <md-button
                  class="md-icon-button"
                  @click="leftSideMenuVisible = !leftSideMenuVisible"
                >
                  <md-icon>menu</md-icon>
                </md-button>

                <span class="md-title" v-if="isCategoryView"
                  >Choose treatment type</span
                >
              </section>
              <app-admin-nav-row v-if="isAdminView" />
              <app-user-nav-title v-else />
            </div>
            <div class="md-toolbar-section-end">
              <md-menu md-direction="bottom-end">
                <md-button class="md-icon-button" md-menu-trigger>
                  <md-icon>more_vert</md-icon>
                </md-button>
                <md-menu-content style="z-index: 11">
                  <md-menu-item disabled @click="data = 'click disabled'"
                    >Select option</md-menu-item
                  >
                  <md-menu-item
                    @click="switchToUserView()"
                    v-if="isAdminView || isLoginView"
                    >Switch to User View</md-menu-item
                  >
                  <md-menu-item @click="trySwitchToAdmin()" v-else
                    >Switch to Admin</md-menu-item
                  >

                  <md-menu-item @click="signOut" v-if="isLoggedIn"
                    >Sign Out</md-menu-item
                  >
                  <md-menu-item @click="login" v-else>Login</md-menu-item>
                  <md-menu-item @click="closeDialog">Exit</md-menu-item>
                </md-menu-content>
              </md-menu>
            </div>
          </div>
        </md-app-toolbar>

        <md-app-content
          style="min-height: 400px"
          v-bind:class="{
            'user-view': !isAdminView,
            'admin-view': isAdminView,
          }"
        >
          <router-view />
        </md-app-content>
        <md-app-drawer
          class="md-left"
          md-swipeable
          :md-active.sync="leftSideMenuVisible"
        >
          <app-admin-drawer v-if="isAdminView" />
          <app-categories-user-drawer v-else />
        </md-app-drawer>
      </md-app>
      <md-drawer
        style="width: 200px"
        class="md-right"
        v-if="isAdminView"
        :md-active.sync="menuRightVisible"
        md-swipeable
      >
        <app-admin-menu-options />
      </md-drawer>
      <md-dialog-actions>
        <app-create-admin-dialog-actions v-if="isLoginView" />
        <md-button class="md-primary" @click="closeDialog">Close</md-button>
        <app-admin-dialog-actions v-if="isAdminView" />
        <app-booking-dialog-actions v-if="!isAdminView && !isLoginView" />
        <app-login-dialog-actions v-if="isLoginView" />
      </md-dialog-actions>
    </md-dialog>

    <!-- Floating button -->
    <md-button class="md-primary md-raised" @click="onShowDialogButtonClick"
      >Book Now</md-button
    >

    <app-snackbar />
  </div>
</template>
 
<script>
import UserNavTitle from "@/components/BookingApp/UserView/UserNavTitle";
import CategoriesUserDrawer from "@/components/BookingApp/UserView/Menu/CategoriesUserDrawer";
import AdminDrawer from "@/components/BookingApp/AdminView/AdminDrawer";
import AdminMenuOptions from "@/components/BookingApp/AdminView/AdminMenuOptions";

// import UserView from "./UserView/UserView";
// import AdminContent from "./AdminView/AdminContent";
import BookingDialogActions from "@/components/BookingApp/UserView/BookingDialogActions";

import { eventBus } from "@/components/BookingApp/eventbus";
import AdminDialogActions from "@/components/BookingApp/AdminView/AdminDialogActions";
import LoginDialogActions from "@/components/BookingApp/UserView/Login/LoginDialogActions";
import CreateAdminDialogActions from "@/components/BookingApp/UserView/Login/CreateAdminDialogActions";
import AdminNavRow from "@/components/BookingApp/AdminView/AdminNavRow";
import firebase from "./firebaseConfig";
import { onAuthStateChanged } from "@/components/BookingApp/onAuthStateChanged";
import Snackbar from "@/components/BookingApp/Shared/Snackbar";

export default {
  name: "bookingApp",
  components: {
    appUserNavTitle: UserNavTitle,
    appCategoriesUserDrawer: CategoriesUserDrawer,
    appAdminDrawer: AdminDrawer,
    appAdminMenuOptions: AdminMenuOptions,
    appBookingDialogActions: BookingDialogActions,
    appAdminDialogActions: AdminDialogActions,
    appLoginDialogActions: LoginDialogActions,
    appCreateAdminDialogActions: CreateAdminDialogActions,
    appAdminNavRow: AdminNavRow,
    appSnackbar: Snackbar,
  },
  data: function () {
    return {
      showDialog: false,
      menuRightVisible: false,
      isCategoryView: true,
      selectedCategory: "",
      selectedCategoryIndex: 0,
      treatments: [],
      selectedTreatment: null,

      customerFormVisible: false,
      selectedTime: null,
      selectedDate: new Date(),
      timeReserved: false,
      yourEmailMobile: "",
      hasBooked: false,
      showContactForm: true,
      showBookNowButton: true,
      isLoginView: false,
      isAdminUI: false,
    };
  },
  computed: {
    menuData() {
      return this.$store.state.menuData;
    },
    showNavRow: {
      get: function () {
        return this.$store.state.showNavRow;
      },
      set: function (value) {
        this.$store.commit("NAV_ROW_VISIBLE", value);
      },
    },
    isAdminView: {
      get: function () {
        return this.isAdminUI && this.isAdmin;
      },
      set: function (value) {
        this.isAdminUI = value;
      },
    },
    leftSideMenuVisible: {
      get: function () {
        return this.$store.state.showLeftSideMenu;
      },
      set: function (value) {
        this.$store.commit("LEFT_SIDE_MENU_VISIBLE", value);
      },
    },
    menuUrl() {
      return this.$store.getters.menuUrl;
    },
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
  },

  methods: {
    onShowDialogButtonClick: function () {
      var self = this;

      eventBus.showBookingDialog();

      self.showDialog = true;

      if (this.isLoggedIn && this.isAdmin) {
        this.switchToUserView();
        console.log("isLoggedIn", this.isLoggedIn);
        this.trySwitchToAdmin();
      }
    },
    closeDialog: function () {
      // Before closing the dialog make sure no sidebar is opened
      if (this.leftSideMenuVisible) {
        this.leftSideMenuVisible = false;
      } else {
        this.showDialog = false;
        eventBus.closeBookingDialog();
      }
    },
    switchToUserView: function () {
      eventBus.isLoginView(false);
      this.isAdminView = false;
      this.$router.push("/category");
    },
    trySwitchToAdmin: function () {
      console.log("trySwitchToAdmin called");
      this.$router.push("/admin");
      // check if user is allowed to see admin dashboard
      // - is logged in and is associated to current website url
      //    if not associated then show message: access denied (ask your Admin to allow access)
      //
      // if not then redirect to login page

      var self = this;

      // switch back to user view
      if (self.isLoginView) {
        eventBus.isLoginView(false);
        self.isAdminView = false;
      } else {
        if (this.isLoggedIn && this.isAdmin) {
          this.isAdminView = true;
          console.log("switchToAdmin: isLoggedIn && hasAdminRole is true");
        } else {
          this.isAdminView = false;

          if (this.isLoggedIn) {
            // TODO access not allowed redirect to normal user view, show a toast message "ask your admin to give you permissions"
            console.log(
              "switchToAdmin: isLoggedIn is true but does not have admin role"
            );
            this.isAdminView = true;
          } else {
            // TODO redirect to Login page
            eventBus.isLoginView(true);
          }
        }
      }
    },
    signOut: function () {
      console.log("TODO sign out");
      //this.store.sharedState.signOut();
      this.$store.dispatch("auth/signOut");

      // navigate to user home page
      this.$router.push({ name: "Categories" });
    },
    login: function () {
      this.$router.push("/login");
    },
  },
  watch: {
    $route(to, from) {
      console.log(`Router: ${from.path} => ${to.path}`);

      this.isCategoryView = to.path == "/category";

      if (this.isCategoryView) this.showNavRow = false;
      else this.showNavRow = true;
    },
    menuUrl(to, from) {
      console.log("watch menuUrl to, from", to, from);

      // fetch the data when the view is created and the data is
      // already being observed
      this.$store.dispatch("loadMenu");
    },
    menuData(to) {
      console.log("Menu data change", to);

      if (this.$store.state.menuData.length == 0) {
        // redirect to login page and show create admin account link
        this.$store.state.showCreateAdminLink = true;
        eventBus.isLoginView(true); // TODO check if correct view state, move to Vuex
      }
    },
  },
  created: async function () {
    var self = this;

    eventBus.$on("selected-treatment", function (treatment) {
      self.selectedTreatment = treatment;
    });
    eventBus.$on("selected-category", function (category, index) {
      self.selectedCategory = category;
      self.selectedCategoryIndex = index;
    });
    eventBus.$on("open-close-left-sidemenu", function (open) {
      self.leftSideMenuVisible = open;
    });

    eventBus.$on("switch-to-admin-view", function () {
      self.trySwitchToAdmin();
    });
    eventBus.$on("open-close-admin-right-drawer", function (isOpen) {
      self.menuRightVisible = isOpen;
      console.log("open-close-admin-right-drawer", isOpen);
    });
    eventBus.$on("is-login-view", function (value) {
      // self.showNavRow = !value;

      self.isLoginView = value;
      console.log("on: is log in view");
    });
    eventBus.$on("user-signed-in", function (user, claims) {
      console.log("idTokenResult.claims", claims);

      self.$store.state.menuId = claims?.menu;

      self.$store.dispatch("loadMenu").then((result) => {
        console.log("self.$store.dispatch(`loadMenu`)", result);
      });
      // Confirm the user is an Admin.
      if (claims != null && claims.admin) {
        // Show admin UI.
        self.$store.state.isAdmin = true;
      } else {
        // Show regular user UI.
        // showRegularUI();
      }
    });

    var db = firebase.database().ref(this.$store.state.menuId + "/data");
    console.log("TODO here");

    db.on("child_changed", function (data) {
      console.log("TODO here", data);
      // self.store.sharedState.clearMenuData();
      // self.store.sharedState.refreshMenuData();

      // eventBus.menuDataChanged(data.key);
    });
    db.on("child_removed", function (data) {
      console.log("TODO here", data);
      // self.store.sharedState.clearMenuData();
      // self.store.sharedState.refreshMenuData();

      // eventBus.menuDataChanged(data.key);
    });
    // todo, it fires to many times
    // db.on("child_added", function (data) {
    //   eventBus.menuDataChanged(data.key);
    // });
    db.on("child_moved", function (data) {
      console.log("TODO here", data);
      // self.store.sharedState.clearMenuData();
      // self.store.sharedState.refreshMenuData();

      // eventBus.menuDataChanged(data.key);
    });

    onAuthStateChanged();

    // Confirm the link is a sign-in with email link.
    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      var email = window.localStorage.getItem("emailForSignIn");
      if (!email) {
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        email = window.prompt("Please provide your email for confirmation");
      }

      if (email)
        // The client SDK will parse the code from the link for you.
        firebase
          .auth()
          .signInWithEmailLink(email, window.location.href)
          .then(function (result) {
            // Clear email from storage.
            // TODO uncomment line below
            //window.localStorage.removeItem("emailForSignIn");

            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null

            // TODO ask user for his display name hee?
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
            self.showDialog = true;
            console.log("the user is loggged in", result.user);
          })
          .catch(function (error) {
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
            //for example auth/invalid-action-code
            console.log("error", error);

            //TODO show a toast message with error?
            eventBus.newSnackbar("Error: " + error.code, "login");
          });
    }
  },
  mounted: function () {
    // Retreive menu id to load initial menu data
    this.$store.state.menuId = document.querySelector("sneos-booking").id;
    console.log("mouonted booking app", this.$store.state.menuId);
  },
};
</script>
 
<style type="text/scss" lang="scss" scoped>
sneos-booking {
  @import url("https://fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons");

  #sneosapp {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-weight: 300;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #a61111;
    margin-top: 60px;

    left: 57px;
    top: 55%;
    position: absolute;
    z-index: 5;
    background: white;
    border: 1px solid gray;
    max-width: 450px;
  }
}

/* Responsive layout - makes the menu and the content (inside the section) sit on top of each other instead of next to each other */
@media (max-width: 4000px) {
  section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}

.user-view {
  min-width: 340px;
}
.admin-view {
  width: 640px;
}
</style>
 